import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'app-recaptcha-challenge',
  templateUrl: './recaptcha-challenge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecaptchaChallengeComponent {
  @ViewChild(RecaptchaComponent) private captcha?: RecaptchaComponent;

  @Output() solved = new EventEmitter<string>();
  @Output() expired = new EventEmitter<void>();

  onResolved(token: string | null): void {
    // ng-recaptcha emits null when the widget expires or is reset.
    token ? this.solved.emit(token) : this.expired.emit();
  }

  /** Clears the current (possibly consumed/solved) challenge so a fresh v2 can be solved. */
  reset(): void {
    this.captcha?.reset();
  }
}
